const sub = [
  {
    label: 'Jobs',
    isRoute: true,
    name: 'dashboard::pro::jobs',
  },
  {
    label: 'Schedule',
    isRoute: true,
    name: 'dashboard::pro::agenda',
  },
  {
    label: 'Messages',
    isRoute: true,
    name: 'dashboard::pro::messages',
  },
];
const main = [
  {
    label: 'Access Pro Xtra',
    isRoute: false,
    icon: 'pro-underline',
    size: 20,
  },
  {
    label: 'Pro Education',
    isRoute: true,
    name: 'dashboard::pro::education',
    icon: 'play-circle',
  },
  {
    label: 'Help Center',
    isRoute: false,
    icon: 'question-circle',
  },
  {
    label: 'What\'s new?',
    isRoute: true,
    name: 'dashboard::pro::notifications',
    icon: 'bell-outline',
  },
  {
    label: 'Performance',
    isRoute: true,
    name: 'dashboard::pro::performance',
    icon: 'rise',
  },
  {
    label: 'Account',
    name: 'account::info',
    isRoute: true,
    icon: 'user',
  },
  {
    label: 'Sign Out',
    isRoute: false,
    icon: 'logout',
  },
];
const account = [
  {
    label: 'Account Info',
    isRoute: true,
    name: 'account::info',
  },
  {
    label: 'Occupations',
    isRoute: true,
    name: 'account::pro::occupation',
  },
  {
    label: 'Invite a Pro',
    isRoute: true,
    name: 'account::pro::invite',
  },
  {
    label: 'Tools & Offers',
    isRoute: true,
    name: 'account::pro::tools',
  },
];

export default {
  main,
  sub,
  account,
};
